<template>
    <div class="pageBox">
        <div class="pageFrame">
            <el-tabs v-model="activeName" tab-position="left" class="content" @tab-click="handleClick_parent">
                <el-tab-pane :label="item.typeName" :name="'tab' + index" v-for="(item, index) in about" :key="index"
                    v-html="item.content">
                </el-tab-pane>
                <el-tab-pane label="资质荣誉" name="tabHonor">
                    <!-- <div class="poperBox" v-show="isShowPoper">
                        <div class="poper">
                            <div class="titleRow">
                                <div class="title">{{ title }}</div>
                                <div class="close" @click="closePoper()">×</div>
                            </div>
                            <img class="content" :src="contentValue"/>
                        </div>
                    </div> -->
                    <el-tabs type="card" v-model="activeName_honor" @tab-click="handleClick">
                        <el-tab-pane label="企业资质" name="honor1">
                            <div class="item_scan" v-for="(item, index) in qualification" :key="index">
                                <div class="name">{{ item.qualificationName }}</div>
                                <div class="scan" @click="scanBtn(item.qualificationName, item.qualificationImg)">点击预览
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="企业荣誉" name="honor2">
                            <div class="item_scan" v-for="(item, index) in honor" :key="index">
                                <div class="name">{{ item.qualificationName }}</div>
                                <div class="scan" @click="scanBtn(item.qualificationName, item.qualificationImg)">点击预览
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="pagination">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="pageIndex" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog :title="title" :visible.sync="isShowPoper" width="50%">
            <div class="dialog-lab-container">
                <img class="content" :src="contentValue"/>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "about",
    data() {
        return {
            //类别索引
            activeName: 'tab0',
            //索引
            activeName_honor: 'honor1',
            //页面类别、内容
            about: [],
            //资质
            qualification: [],
            //荣誉
            honor: [],
            isShowPoper: false,
            title: '',
            contentValue: '',
            wait: true,
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0
        }
    },
    watch: {
        'activeName'() {
            this.getAbout()
            this.getAboutIndex()
        }
    },
    mounted() {
        this.$store.commit('setNav', 5)
        document.title = '关于中安' + this.$suffix
        this.getAbout()
        this.getAboutIndex()
    },
    methods: {
        /**
         * 浏览
         */
        scanBtn(name, content) {
            if (this.wait) {
                this.wait = false
                this.title = name
                this.contentValue = content
                this.isShowPoper = !this.isShowPoper
                setTimeout(() => {
                    this.wait = true
                }, 1500)
            }
        },

        /**
         * 关闭
         */
        closePoper() {
            this.isShowPoper = false
        },

        /**
         * 获取数据
         */
        getAbout() {
            this.$get('/V1/About/GetAboutList', {})
                .then((res) => {
                    // console.log('about', res)
                    if (res.success) {
                        this.about = res.response
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 获取荣誉资质
         */
        getHonor(index) {
            this.$post('/V1/CompanyHonor/GetCompanyQualificationList', {
                "pageSize": this.pageSize,
                "pageIndex": this.pageIndex,
                "type": index
            })
                .then((res) => {
                    // console.log('honor', res)
                    if (res.success) {
                        this.totalCount = res.response.totalCount
                        if (index == 1) {
                            this.qualification = res.response.data
                        } else {
                            this.honor = res.response.data
                        }
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 分页大小监听
         */
        handleSizeChange(val) {
            this.pageSize = val
            this.handleClick()
        },

        /**
         * 分页当前页监听
         */
        handleCurrentChange(val) {
            this.pageIndex = val
            this.handleClick()
        },

        /**
         * 获取索引
         */
        getAboutIndex() {
            this.activeName = this.$store.state.aboutIndex
            this.handleClick_parent()
        },

        /**
         * 一级tab点击监听
         **/
        handleClick_parent() {
            if (this.activeName == 'tabHonor') {
                this.handleClick()
            }
        },

        /**
         * 资质、荣誉点击监听
         */
        handleClick() {
            let index = 1
            if (this.activeName_honor == 'honor2') {
                index = 2
            }
            this.getHonor(index)
        }
    }
}
</script>

<style scoped lang="less">
.pageBox {
    width: 100%;
    background-color: #f9f9f9;

    .pageFrame {
        padding: 20px 0px;
        width: 1210px;
        margin: 0 auto;


        ::v-deep .el-tabs--left {
            padding: 40px 0px;
        }

        ::v-deep .el-tabs--left .el-tabs__header {
            background-color: white;
            padding: 40px 0px;
            box-shadow: 0px 0px 8px 0px #d7d7d7;
            margin-right: 30px;
        }

        ::v-deep .el-tabs--left .el-tabs__content {
            min-height: 400px;
            width: 960px;
            max-width: 960px;
            overflow: hidden;
        }

        ::v-deep .el-tabs--left .el-tabs__content img {
            max-width: 920px;
        }

        ::v-deep .el-tabs--left .el-tabs__content table {
            max-width: 920px;
        }

        ::v-deep .el-tabs--left .el-tabs__item {
            font-size: 18px;
            width: 220px;
            text-align: center;
        }

        ::v-deep .el-tabs--card {
            background-color: white;
            box-shadow: 0px 0px 4px 0px #E4E7ED;
        }

        ::v-deep .el-tabs--card .el-tabs__header {
            background-color: #F5F7FA;
            padding: 0px;
            box-shadow: 0px 0px 0px 0px transparent;
            margin: 0px;
        }

        ::v-deep .el-tabs--card .el-tabs__content {
            min-height: 400px;
            background-color: transparent;
            width: 880px;
            max-width: 880px;
            padding: 20px 40px;
            overflow: hidden;
            box-shadow: 0px 0px 0px 0px transparent;
            border: 1px solid #E4E7ED;
            border-top: none;
            margin: 0 !important;
        }

        ::v-deep .el-tabs--card .is-active {
            background-color: white;
        }

        ::v-deep .el-tabs--card .el-tabs__item {
            width: 100px;
            padding: 0 !important;
            text-align: center;
            font-size: 15px;
        }

        // .poperBox {
        //     width: 100%;
        //     height: 100%;
        //     position: fixed;
        //     top: 50%;
        //     left: 50%;
        //     transform: translate(-50%, -50%);
        //     display: flex;
        //     flex-direction: row;
        //     align-items: center;
        //     justify-content: center;
        //     background-color: rgba(0, 0, 0, 0.5);
        //     z-index: 999999;

        //     .poper {
        //         padding: 5px 20px 20px;
        //         width: 1100px;
        //         height: 70%;
        //         box-shadow: 0px 0px 2px 0px #c9c9c9;
        //         background-color: white;
        //         overflow: auto;
        //         border-radius: 4px;
        //         position: relative;
        //         display: flex;
        //         flex-direction: column;
        //         align-items: center;

        //         .titleRow {
        //             display: flex;
        //             flex-direction: row;
        //             justify-content: space-between;
        //             align-items: center;
        //             margin-bottom: 20px;
        //             width: 100%;
        //             z-index: 99;

        //             .title {
        //                 max-width: 1000px;
        //                 overflow: hidden;
        //                 text-overflow: ellipsis;
        //                 white-space: nowrap;
        //                 font-size: 18px;
        //                 font-weight: bold;
        //             }

        //             .close {
        //                 position: absolute;
        //                 top: 0;
        //                 right: 0;
        //                 font-size: 30px;
        //                 cursor: pointer;
        //                 width: 40px;
        //                 height: 30px;
        //                 line-height: 30px;
        //                 text-align: center;
        //             }

        //             .close:hover {
        //                 background-color: #ea0000;
        //                 color: white;
        //             }
        //         }

        //         .content {
        //             margin: auto auto;
        //             box-shadow: 0 0 5px 0 #cbcbcb;
        //             max-width: 100%;
        //         }
        //     }
        // }

        .item_scan {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            margin-top: 10px;

            .name {
                max-width: 750px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 16px;
                color: #333;
            }

            .scan {
                width: 100px;
                height: 38px;
                background: #1f2d5c;
                color: #fff;
                font-size: 14px;
                border-radius: 4px;
                text-align: center;
                line-height: 38px;
                cursor: pointer;
            }

            .scan:hover {
                box-shadow: 0px 0px 2px 0px #1f2d5c;
            }
        }

        .pagination {
            width: 1210px;
            margin: 0 auto;
        }
    }

    .dialog-lab-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
